/*
  Drives the "Bundle & Save" tile's scent-picker drawer
  (snippets/variant-button.liquid). Clicking the tile opens a drawer where
  the customer picks the product's configured bundle_discount_quantity of
  scents from THIS product's own variants (Add+/stepper per scent, same
  interaction pattern as assets/bundle-buy-box.js). On completion, each
  picked scent is added to /cart/add.js as its own real line item, tagged
  with a shared "_Bundle"/"_Bundle Id" property pair — the same real-line-item
  pattern the Solid Cologne Bundle uses, so this automatically benefits from
  the existing cart grouping/discount-display code
  (assets/ocu-bundle-cart-grouping.js, snippets/cart-item-bundle.liquid) with
  no further wiring. Nothing about pricing is computed here — the actual
  discount is a separate Shopify automatic discount configured in Admin.
*/
(function () {
  function initBundleSavePicker(trigger) {
    if (trigger.dataset.bundleSaveInitialized) return;
    trigger.dataset.bundleSaveInitialized = 'true';

    var pickerId = trigger.getAttribute('aria-controls');
    var picker = pickerId ? document.getElementById(pickerId) : null;
    if (!picker) return;

    var root = trigger.closest('.variant-input-wrap') || document;
    var overlay = root.querySelector('[data-bundle-save-overlay]');
    var closeBtn = picker.querySelector('[data-bundle-save-close]');
    var progress = picker.querySelector('[data-bundle-save-progress]');
    var submitBtn = picker.querySelector('[data-bundle-save-submit]');
    var items = Array.from(picker.querySelectorAll('[data-scent-option]'));
    var slots = parseInt(picker.dataset.slots, 10) || 0;
    var bundleLabel = picker.dataset.bundleLabel || 'Bundle';

    if (!overlay || !slots || !items.length) return;

    // scent value -> quantity chosen. Absent/0 means not chosen.
    var quantities = {};

    function totalSelected() {
      return Object.keys(quantities).reduce(function (sum, key) {
        return sum + quantities[key];
      }, 0);
    }

    function updateItem(item) {
      var value = item.dataset.scentValue;
      var available = item.dataset.variantAvailable !== 'false';
      var qty = quantities[value] || 0;
      var total = totalSelected();
      var addBtn = item.querySelector('[data-scent-add]');
      var stepper = item.querySelector('[data-scent-stepper]');
      var countEl = item.querySelector('[data-stepper-count]');
      var incBtn = item.querySelector('[data-stepper-increment]');
      var decBtn = item.querySelector('[data-stepper-decrement]');

      if (qty > 0) {
        if (addBtn) addBtn.hidden = true;
        if (stepper) stepper.hidden = false;
        if (countEl) countEl.textContent = String(qty);
        if (decBtn) decBtn.disabled = false;
        if (incBtn) incBtn.disabled = !available || total >= slots;
      } else {
        if (addBtn) {
          addBtn.hidden = false;
          addBtn.disabled = !available || total >= slots;
        }
        if (stepper) stepper.hidden = true;
      }
    }

    function updateProgress() {
      if (progress) progress.textContent = 'Selected ' + totalSelected() + ' of ' + slots;
    }

    function validate() {
      var remaining = slots - totalSelected();
      if (submitBtn) submitBtn.disabled = remaining !== 0;
      return remaining === 0;
    }

    function refreshAll() {
      items.forEach(updateItem);
      updateProgress();
      validate();
    }

    function trapFocus() {
      if (window.theme && theme.a11y && typeof theme.a11y.trapFocus === 'function') {
        theme.a11y.trapFocus({ container: picker, elementToFocus: closeBtn, namespace: 'bundleSavePicker' });
      }
    }
    function releaseFocus() {
      if (window.theme && theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({ container: picker, namespace: 'bundleSavePicker' });
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closePicker();
    }

    function openPicker(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      overlay.hidden = false;
      picker.hidden = false;
      refreshAll();
      trapFocus();
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closePicker() {
      overlay.hidden = true;
      picker.hidden = true;
      releaseFocus();
      document.removeEventListener('keydown', onKeydown);
      trigger.focus();
    }

    trigger.addEventListener('click', openPicker);
    if (closeBtn) closeBtn.addEventListener('click', closePicker);
    overlay.addEventListener('click', closePicker);

    items.forEach(function (item) {
      var value = item.dataset.scentValue;
      var addBtn = item.querySelector('[data-scent-add]');
      var incBtn = item.querySelector('[data-stepper-increment]');
      var decBtn = item.querySelector('[data-stepper-decrement]');

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (item.dataset.variantAvailable === 'false') return;
          if (totalSelected() >= slots) return;
          quantities[value] = 1;
          refreshAll();
        });
      }
      if (incBtn) {
        incBtn.addEventListener('click', function () {
          if (item.dataset.variantAvailable === 'false') return;
          if (totalSelected() >= slots) return;
          quantities[value] = (quantities[value] || 0) + 1;
          refreshAll();
        });
      }
      if (decBtn) {
        decBtn.addEventListener('click', function () {
          if (!quantities[value]) return;
          quantities[value] -= 1;
          if (quantities[value] <= 0) delete quantities[value];
          refreshAll();
        });
      }
    });

    function computeItemsPayload() {
      var bundleId = 'bundle-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
      var payload = [];
      items.forEach(function (item) {
        var value = item.dataset.scentValue;
        var qty = quantities[value] || 0;
        if (qty <= 0) return;
        var variantId = parseInt(item.dataset.variantId, 10);
        if (!Number.isFinite(variantId)) return;
        payload.push({
          id: variantId,
          quantity: qty,
          properties: {
            _Bundle: bundleLabel,
            '_Bundle Id': bundleId,
          },
        });
      });
      return payload;
    }

    // Same wait-then-open approach as assets/bundle-buy-box.js: OCU refreshes
    // its own Slide Cart Drawer asynchronously after a cart change, so
    // opening it immediately can show stale/empty content even though the
    // real cart already has the new lines.
    function openOcuDrawerWhenReady() {
      var drawerTrigger = document.querySelector('.js-drawer-open-cart');
      if (!drawerTrigger) return;
      setTimeout(function () {
        drawerTrigger.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
      }, 500);
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!validate()) return;

        var payload = computeItemsPayload();
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: payload }),
          credentials: 'same-origin',
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (body) {
                throw new Error(body.description || 'Could not add this bundle to your cart.');
              });
            }
            return res.json();
          })
          .then(function () {
            closePicker();
            quantities = {};
            try {
              document.dispatchEvent(new CustomEvent('cart:build'));
            } catch (e) {
              /* no-op */
            }
            openOcuDrawerWhenReady();
          })
          .catch(function (err) {
            if (progress) progress.textContent = err.message;
          })
          .finally(function () {
            submitBtn.classList.remove('is-loading');
            validate();
          });
      });
    }

    refreshAll();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-save-trigger]').forEach(initBundleSavePicker);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
